import React from "react";
import "./Realspad_nft.css";
import nft from "../Assets/nft.jpg";
import hit from "../Assets/nft.jpg";

export default function Realspad_nft() {
  return (
    <div className="main_realspad_nft">
      <div className="container">
        <div className="row mt-4">
          <div className="col-md-6 text-start">
            <h1 className="lower_tkn text-start ">Abstract </h1>
            <p className="nft_para">
            Triumph Token (TRH) Is An Innovative Cryptocurrency Designed To Address Liquidity Challenges Faced By Users When Withdrawing Fiat Currency. The Triumph Project Aims To Introduce A Fintech Application By September 2024, Known As Triumph Insta Cash, Which Allows For Seamless Conversion Of Tokens Into Fiat And Facilitates Fast Transfers To Visa Or Mastercard-Enabled Cards With Minimal Fees.
            </p>
            <p className="nft_para">
            Additionally, Triumph Offers Staking Opportunities With Lucrative Rewards, A Unique NFT Collection, And A Sustainable Tokenomics Model Backed By Smart Contracts And Revenue From The Casino And Betting Industry.
            </p>
            <p className="nft_para fw-bold  ">
            This Whitepaper Provides An In-Depth Overview Of Triumph Token, Its Features, Utility, And Roadmap For Development And Adoption.
            </p>
          </div>
          <div className="col-md-6 mt-3 mt-md-0">
            <img src={nft} className="rounded" alt="" />
          </div>
        </div>
        <div className="row align-items-center mt-5">
          <div className="col-md-6 mt-3 mt-md-0">
            <img src={hit} className="rounded" alt="" />
          </div>
          <div className="col-md-6 text-start mt-3 mt-md-0">
            <h1 className="lower_tkn text-start ">TRIUMPH Roadmap</h1>
            <p className="nft_para">
            Phase 1:
Develop the Triumph Token (TRH) smart contract.
Initiate the private sale offering 10,000 TRH at $0.01 .
            </p>
            <p className="nft_para">
            Phase 2:
• Launch the first stage of the presale offering TRH at $0.03 .
• Commence the second stage of the presale offering TRH at $0.05 .
• Begin development of Triumph Insta Cash fintech application.
• Focus on token-to-fiat conversion and card transfers.
            </p>  <p className="nft_para">
            Phase 3:
Launch the staking platform with APY rewards and subscription bonuses.
Implement unrestricted trading for TRH tokens without vesting or TGE periods.
List Triumph Token (TRH) on major exchanges such as PancakeSwap, ApeSwap, Gate.io, CoinEX, LCX, and Uphold.
            </p>  <p className="nft_para">
            Phase 4:
Launch beta version of Triumph Insta Cash for trial period.
Release the NFT collection featuring memorable crypto moments from 2024.
Prepare for the launch of the staking platform with rewards and bonuses.
            </p>
            <p className="nft_para">
            Phase 5:
Activate the token buyback and burn mechanism to enhance token value.
Ramp up marketing efforts to promote Triumph Token and engage with the community.
Forge strategic partnerships with other blockchain projects and fintech companies.
Focus on global adoption and expansion into new markets.
Explore additional features and services to enhance the Triumph ecosystem.
Transition towards community governance and decentralization.
Empower token holders to participate in decision-making processes
            </p>
            {/* <ul>
              <li className="hw_lis fw-blod">
                Staked tokens are used by Triumph Token(TRH) for various purposes:
              </li>
              <li className="hw_lis">
              <span className="fw-bold">   Purchase of properties:</span> Triumph Token(TRH) uses staked funds to acquire
                properties.
              </li>
              <li className="hw_lis">
              <span className="fw-bold">  Leasing of properties: </span> Triumph Token(TRH) leases the purchased properties
                to generate rental income.
              </li>
              <li className="hw_lis">
              <span className="fw-bold">  Development of sites: </span> Triumph Token(TRH) utilizes staked funds for
                developing properties/sites, increasing their value.
              </li>
              <li className="hw_lis">
              <span className="fw-bold">    Marketing at a higher price: </span> Triumph Token(TRH) promotes the
                properties/sites to attract potential buyers or tenants at a
                premium price.
              </li>
              <li className="hw_lis">
              <span className="fw-bold">   Profit generation: </span> The revenue generated from property leasing,
                property sales, and site development is considered profit.
              </li>
              <li className="hw_lis">
              <span className="fw-bold">    Deducting company expenditures: </span> Triumph Token(TRH) deducts its operational
                expenses, such as maintenance costs, marketing expenses, and
                management fees, from the generated profit.
              </li>
              <li className="hw_lis">
              <span className="fw-bold">  Profit distribution: </span> After deducting the expenditures, Triumph Token(TRH)
                distributes a portion of the remaining profit to the token
                stakers. Token stakers receive their share of profit according
                to the number of tokens they stake. Investors can choose to
                reinvest their profits, sell their tokens on the open market, or
                hold them for future participation in the project.
                Triumph Token(TRH) TOKENOMICS
              </li>
            </ul> */}
          </div>
        </div>
      </div>
    </div>
  );
}
